import { createLogic } from 'redux-logic';
import { clearRolesStateAfterSwitchBranch } from './actions';
// features
import { receivedSwitchBranchSuccess } from '../branch/actions';
//////////////////////////////////////////////////

export const handleSwitchBranchLogic = createLogic({
  type: receivedSwitchBranchSuccess,
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    dispatch(clearRolesStateAfterSwitchBranch());
    done();
  },
});

export default [
  handleSwitchBranchLogic,
];
